import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteSavedViewDialog } from "./DeleteSavedViewDialog";
import { deleteHttp } from "../../../api/apiShared";
import { Result } from "../../../api/result";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useDeleteSavedViewHook(props: IDeleteSavedViewDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeViewClick = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                snackbar.show(createElement(Trans, { i18nKey: "savedViewDeleted", values: { name: props.view.name } }));
                props.onSuccessDelete();
            },
        });
    };

    return {
        removeViewClick,
        inProgress: removeMutation.isLoading,
    };

    async function remove() {
        return await deleteHttp<string>(`/saved-views/${props.view.id}`);
    }
}
